// TODO: right now we are handling the re-sending of error message templates by filtering on the frontend
// at some point we should refactor the messages feed service instead
const removeDuplicatesByProperty = (prop: string) => (arr: object[]) => {
    const uniqueItemsByProp = {};
    const itemsWithoutProp = [];

    // sort out items that do not have the properties
    // create an object of items indexed by property value
    // return an array of unique items
    const uniqueItems = Object.keys(arr.reduce((prev, next) => {
        if (!next[prop]) {
            itemsWithoutProp.push(next);
            return uniqueItemsByProp;
        }

        if (!uniqueItemsByProp[next[prop]]) {
            uniqueItemsByProp[next[prop]] = next;
        }

        return uniqueItemsByProp;
    }, uniqueItemsByProp)).map((objProp) => uniqueItemsByProp[objProp]);

    // return merged array of unique items and items that did not have the property
    return [...uniqueItems, ...itemsWithoutProp];
};

export const removeDuplicatesByTemplateId = removeDuplicatesByProperty('message_template_id');



// WEBPACK FOOTER //
// ./src/helpers/messageTemplate.ts